( function ( $ ) {

  const cache = {};
  function cache_posts ( posts ) {
    posts.forEach( post => {
      if ( post.hasOwnProperty( 'html' ) ) {
        cache[ post.id ] = post.html;
      }
    })
  }

  function resize ( $card ) {
    $card.css( '--ch', `${ $( '.content', $card ).outerHeight() }px` )
    requestAnimationFrame( () => $card.addClass( 'calcd' ) )

    const $cw = $( '.calc-w', $card )
    if ( $cw.length ) {
      $cw.css( 'width', 'initial' )
      const max = $( '>span', $cw ).get(0).getBoundingClientRect().width
      $cw.css( 'width', `${ max }px` )
    }
  }

  const ro = new ResizeObserver( entries => {
    for ( let entry of entries ) {
      resize( $( entry.target ) )
    }
  })

  function get_terms ( $section ) {
    const terms = {}
    $( 'div.tax-selects select', $section ).each( function () {
      const $select = $(this)
      const val = $select.val()
      if ( val ) {
        terms[ $select.data('tax') ] = val
      }
    })
    return terms
  }

  function query ( $section, page = null ) {
    $list = $( '.post-list', $section )
    $pagination = $( '.pagination', $section )
    ThemeJS.Functions.wp_rest_request({
      endpoint: 'post-archive/load-page',
      data: {
        qargs: $section.data( 'qargs' ),
        targs: $section.data( 'targs' ),
        terms: get_terms( $section ),
        page: page ?? 1,
        cached: Object.keys( cache ),
      },
      success: function ( res ) {
        cache_posts( res.posts )
        $list.html( res.posts.map( x => cache[ x.id ] ).join('') )
        $( '.ol-card', $list ).each( function () {
          ro.observe( this )
        })
        $pagination.replaceWith( res.pagination )
        if ( page ) {
          $( `.page-numbers[aria-current=true]`, $section ).first().focus()
        }
        ThemeJS.Functions.scroll_to( $list, {
          direction: 'up',
          offset: 20,
        });
      }
    })
  }

  $( 'section.post-archive' ).each( function () {
    const $section = $(this)
    const $list = $( '.post-list', $section )

    $( '.ol-card', $list ).each( function () {
      ro.observe( this )
    })

    const to_cache = $( '> li', $list ).toArray().map( el => {
      return {
        id: parseInt( $( el ).data( 'id' ) ),
        html: el.outerHTML
      }
    });
    cache_posts( to_cache )

    if ( $( 'div.tax-selects', $section ).length ) {
      $section.on( 'change', 'div.tax-selects select', function () {
        query( $section );
      });
    }

    if ( $( '.pagination', $section ).length ) {
      $section.on( 'click', 'button.page-numbers', function () {
        const page = $(this).data( 'page' )
        query( $section, page );
      })
    }
  })

})( jQuery );